<template>
  <div class="page-wrap">
    <div class="content-wrap">
      <div class="feature-title" :style="featureTitle"></div>
      <div class="feature-content">
        <div class="feature-wrap">
          <template v-for="(item, index) in featureArr">
            <div class="item-title" :key="index">
              <span class="item-icon"></span>
              <span>{{item.title}}</span>
            </div>
            <div class="feature-item-list" :key="'li'+index">
              <div
                v-for="(li, liIndex) in item.list"
                :key="liIndex"
                :class="'feature-item ' + li.className"
              >
                <div class="item-top"></div>
                <div class="item-detail">
                  <p>{{li.text}}</p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="graduates">
        <div class="module-label">应届生在文华</div>
        <div class="graduates-content">
          <div class="timeline">
            <img :src="img" style="width:25rem" alt />
            <div class="time-text" style="margin-left:0.4rem;">在这里，毕业第一年，相信你已经能够完全独立，或许还能照顾你的父母；</div>
            <div
              class="time-text"
              style="margin-left:1.5rem;"
            >在这里，毕业第三年，相信你已经拥有了一套自己的房子，并已经做好和你的TA携手一生的准备；</div>
            <div class="time-text" style="margin-left:2rem;">在这里，毕业第五年，相信你已经品尝到了为人父母的喜悦和幸福；</div>
            <div class="time-text" style="margin-left:2.4rem;">在这里，工作10年时，相信你已经成为了行业精英，依然充满激情的工作和生活；</div>
          </div>
        </div>
      </div>
    </div>
    <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
export default {
  data() {
    return {
      featureTitle: `background: url(${process.env.BASE_URL}ImgFiles/home/tsjz.png) no-repeat center/cover;`,
      img: `${process.env.BASE_URL}ImgFiles/nian.png`,
      featureArr: [
        {
          title: "优越的研究环境",
          list: [
            {
              text: "黄金办公地角，上海总部位于陆家嘴金融中心，大连研发中心位于大连市中心且离海边仅有2公里。",
              className: "blue",
            },
            {
              text: "现代开放式办公环境，舒适的人体工学座椅，1.5米办公桌给你宽敞的个人空间。",
              className: "yellow",
            },
            {
              text: "早餐、咖啡、零食、茶点免费供应，也可以根据需要预定免费晚餐。",
              className: "blue",
            },
            {
              text: "1.5小时午休 + 7.5小时工作制，双休、法定假日休息，劳逸平衡，时刻保有发挥创造的精力。",
              className: "yellow",
            },
          ],
        },
        {
          title: "开放的工作文化",
          list: [
            {
              text: "鼓励创新，每年都有技术创新奖金，有很好的创新氛围。",
              className: "yellow",
            },
            {
              text: "开放交流，研究部、开发部经常举办技术交流会，是创新的摇篮。",
              className: "blue",
            },
            {
              text: "建议直通，每个岗位都可以通过内部网直接递交产品设计建议，好的建议就会被采纳。",
              className: "yellow",
            },
            {
              text: "采用先进的管理程序，实时显示产品进展，你可以在工作的同时了解全局，有很强的参与感。",
              className: "blue",
            },
            {
              text: "沟通交流没有等级之分，开放、坦诚、融洽。",
              className: "blue",
            },
            {
              text: "每季度部门聚餐，每年海岛游、运动会、年会，尽显欢乐！",
              className: "yellow",
            },
            {
              text: "经常举办节日惊喜活动，浓厚的节日气氛，为工作生活增添色彩。",
              className: "blue",
            },
          ],
        },
        {
          title: "体会团队协作的乐趣",
          list: [
            {
              text: "工作协作反馈及时，沟通顺畅，不用层层审批。",
              className: "yellow",
            },
            {
              text: "任务明确、工期合理，在解决工作问题方面同事之间有良好的协作。",
              className: "blue",
            },
            {
              text: "每年评选最佳部门奖，有浓厚的团队精神和协作氛围。",
              className: "yellow",
            },
          ],
        },
        {
          title: "广阔的职业发展空间",
          list: [
            {
              text: "大幅度的增长空间，一共有十几个级别，每提升一个级别月薪涨幅500~2000。",
              className: "blue",
            },
            {
              text: "一年4次晋升机会，达成岗位目标即可晋升下一级别。",
              className: "yellow",
            },
            {
              text: "多种上升路径，综合路径：从工程师到项目负责人，技术路径：从初级到专家。",
              className: "blue",
            },
            {
              text: "新项目会任命项目经理，产生发展机会。",
              className: "yellow",
            },
            {
              text: "员工的贡献会累计成星级，获得更好的待遇。",
              className: "yellow",
            },
            {
              text: "HR每年为每个人进行职业发展健康度测评，给出最优的职业发展建议。",
              className: "blue",
            },
            {
              text: "星级员工可获得进修MBA/EMBA学费补助。",
              className: "yellow",
            },
          ],
        },
        {
          title: "纪念勋章",
          list: [
            { text: "入职十年可获得纪念银币。", className: "blue" },
            { text: "星级员工享座位名牌星级标记。", className: "yellow" },
          ],
        },
        {
          title: "员工关怀",
          list: [
            {
              text: "生日当天享受半天带薪假和一张生日蛋糕券。",
              className: "blue",
            },
            { text: "定期体检，关注你的健康。", className: "yellow" },
            { text: "星级健身卡，为健康助力。", className: "blue" },
            {
              text: "星级员工的父母每年享受一次旅行费用报销。",
              className: "yellow",
            },
            {
              text: "年假、带薪病假、带薪事假、星级年假，全年享受30天以上带薪假。",
              className: "yellow",
            },
            {
              text: "星级员工每年有2个亲属体检名额，父母每年都会收到公司邮寄的节日礼品。",
              className: "blue",
            },
          ],
        },
        {
          title: "学习成长",
          list: [
            {
              text: "每季度举办两次业务培训，分享产品业务、行业前沿信息。",
              className: "blue",
            },
            {
              text: "研究部定期举办分享会，互相分享个人的研究和思考。",
              className: "yellow",
            },
            {
              text: "每个部门有自己的知识库，积累了工作需要的知识和经验。",
              className: "blue",
            },
            { text: "提供800+本免费借阅的书籍。", className: "yellow" },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.page-wrap {
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
}
.content-wrap {
  padding-left: 0.3386rem;
}
.feature-title {
  margin: 1.86rem 0 1.72rem 0;
  height: 1rem;
  width: 4.156rem;
  transform: translateZ(0px);
  -webkit-transform: translateZ(0px);
}

.feature-content {
  position: relative;
}

.feature-wrap .item-title {
  font-size: 0.7rem;
  font-weight: bold;
  margin: 0.885rem 0 0.552rem 0;
}

.feature-wrap .item-title .item-icon {
  width: 0.65rem;
  height: 0.65rem;
  display: inline-block;
  vertical-align: middle;
  background: url(../../assets/img/home/jia.png) no-repeat center/cover;
  margin-right: 0.12rem;
}

.feature-item-list {
  overflow-x: auto;
  /* width: 100%;
  white-space: nowrap;
  vertical-align: top; */
  display: flex;
}

.feature-item {
  position: relative;
  box-sizing: border-box;
  border: 1px #feebd8 solid;
  width: 12rem;
  height: 6.568rem;
  overflow: hidden;
  font-size: 0.65rem;
  /* display: inline-block; */
  margin-right: 0.3386rem;
  box-shadow: -2px 3px 4px rgb(0 0 0 / 20%);
  /* margin: 0 6px 10px 0; */
  /* transition: all 0.3s;
  -webkit-transition: all 0.3s; */
  flex-shrink: 0;
}

.feature-item .item-top {
  height: 0.25rem;
  background: linear-gradient(to right, #ec9d3b, #f6bd69);
}

.yellow {
  border-color: #feebd8;
}
.yellow .item-top {
  background: linear-gradient(to right, #ec9d3b, #f6bd69);
}
/* .yellow:hover {
        border-color: #ec9d3b;
        box-shadow: 5px 5px 7px rgba(0, 0, 0, .2);
        transform: translateY(-5px);
        -webkit-transform: translateY(-5px);
    } */

.blue {
  border-color: #d0dcff;
}
.blue .item-top {
  background: linear-gradient(to right, #6e8de0, #6e8de3);
}
/* .blue:hover {
        border-color: #6e8de0;
        box-shadow: 5px 5px 7px rgba(0, 0, 0, .2);
        transform: translateY(-5px);
        -webkit-transform: translateY(-5px);
    } */

.item-detail {
  padding: 0.91rem 0.38rem 0 0.38rem;
  box-sizing: border-box;
  white-space: normal;
}

.item-detail p {
  line-height: 1.6;
  text-indent: 2em;
  color: #7b7b7b;
}
.graduates {
  margin: 2.59rem 0;
}
.graduates-content {
  width: 100%;
  overflow-x: auto;
  position: relative;
  /* height: 6.78rem; */
}
.point {
  position: absolute;
  width: 100%;
  border-bottom: 0.254rem dotted #4462d9;
  top: 1.6rem;
  width: 0.2rem;
}
.timeline {
  width: 25rem;
  margin-right: 0.3386rem;
}
.time-text {
  display: inline-block;
  width: 4.5rem;
  margin-top: 0.8rem;
  vertical-align: top;
  color: rgb(103, 103, 103);
  font-size: 0.58rem;
  text-align: justify;
  line-height: 1.5;
}
</style>